import _ from "lodash";
import { AlimonyChild } from "../../types/AlimonyChild";
import { getUpdateData, persistAddress, persistPerson } from "./persisterService";
import { persistDocument } from "./AbstractDocumentPersister";
import { apiPatch } from "../Api/apiCall";
import { AlimonyPerson } from "../../types/AlimonyPerson";
import { UseForm } from "../../types/UseForm";
import { Alimony } from "../../types/Products/FamilyLaw/Alimony";

export const persistAlimony = async (updateData: UseForm["values"], origDocument: Alimony) => {
  if (_.isObject(updateData.alimonyPetitioner?.person)) {
    const alimonyPetitionerPersonData = getUpdateData(
      updateData.alimonyPetitioner.person,
      origDocument,
      "alimonyPetitioner.person"
    );
    await persistPerson(origDocument.alimonyPetitioner.person.id, alimonyPetitionerPersonData);
  }

  if (_.isObject(updateData.alimonyPetitioner?.person?.residenceAddress)) {
    const alimonyPetitionerPersonResidenceAddress = getUpdateData(
      updateData.alimonyPetitioner.person.residenceAddress,
      origDocument,
      "alimonyPetitioner.person.residenceAddress"
    );
    await persistAddress(
      origDocument.alimonyPetitioner.person.residenceAddress.id,
      alimonyPetitionerPersonResidenceAddress
    );
  }

  if (_.isObject(updateData.alimonyPetitioner)) {
    const alimonyPetitionerUpdateData = getUpdateData(updateData.alimonyPetitioner, origDocument, "alimonyPetitioner");
    await persistAlimonyPerson(origDocument.alimonyPetitioner.id, alimonyPetitionerUpdateData);
  }

  if (_.isObject(updateData.alimonyPartner?.person)) {
    const alimonyPartnerPerson = getUpdateData(updateData.alimonyPartner.person, origDocument, "alimonyPartner.person");
    await persistPerson(origDocument.alimonyPartner.person.id, alimonyPartnerPerson);
  }

  if (_.isObject(updateData.alimonyPartner?.person?.residenceAddress)) {
    const alimonyPartnerPersonResidenceAddress = getUpdateData(
      updateData.alimonyPartner.person.residenceAddress,
      origDocument,
      "alimonyPartner.person.residenceAddress"
    );
    await persistAlimonyPerson(
      origDocument.alimonyPartner.person.residenceAddress.id,
      alimonyPartnerPersonResidenceAddress
    );
  }

  if (_.isObject(updateData.alimonyPartner)) {
    const alimonyPartnerUpdateData = getUpdateData(updateData.alimonyPartner, origDocument, "alimonyPartner");
    await persistAlimonyPerson(origDocument.alimonyPartner.id, alimonyPartnerUpdateData);
  }

  if (_.isObject(updateData.client?.residenceAddress)) {
    const clientResidenceAddress = getUpdateData(updateData.client.residenceAddress, origDocument, "residenceAddress");
    await persistAddress(origDocument.client.residenceAddress.id, clientResidenceAddress);
  }

  if (_.isObject(updateData.client)) {
    const alimonyClientUpdateData = getUpdateData(updateData.client, origDocument, "client");
    await persistPerson(origDocument.client.id, alimonyClientUpdateData);
  }

  const subEntityRequests: Array<() => Promise<AlimonyChild>> = [];
  if (_.isObject(updateData.children)) {
    _.forEach(updateData.children, (child, index) => {
      const childUpdateData = getUpdateData(child, origDocument, `children[${index}]`);
      const childId = origDocument.children[index].id;
      subEntityRequests.push(() => persistAlimonyChild(childId, childUpdateData));
    });
  }
  await Promise.all(_.map(subEntityRequests, (request) => request()));
  await persistDocument(updateData, origDocument);
};

const persistAlimonyPerson = async (id: number, alimonyData: Partial<AlimonyPerson>) => {
  return await apiPatch("alimony_people", id, alimonyData);
};

const persistAlimonyChild = async (id: number, childData: Partial<AlimonyChild>) => {
  return await apiPatch("alimony_children", id, childData);
};
